import { useContext } from "react";
import {
  findEmpresasV2,
  updateEmpresasV2,
} from "../../../../repositories/qerpapi/erp/prouser/v2/EmpresasRepository";
import { notify } from "../../../../utils/notify";
import TabGuias from "../children/tabsfornecedores/TabGuias";
import { FornecedoresBodyContext } from "../contexts/FornecedoresBodyContext";

const useFornecedoresBodyController = (setLoading, setOpen) => {
  const {
    contacts,
    setContacts,
    financialInfos,
    setFinancialInfos,
    othersInfos,
    setOthersInfos,
    integrations,
    setIntegrations,

    queryParams,
    setQueryParams,
  } = useContext(FornecedoresBodyContext);

  const handleSaveSupplierParams = async () => {
    setLoading(true);
    const supplierParamsBody = {
      guia_fornecedores_contatos: contacts ? 1 : 0,
      guia_fornecedores_infosfinanceiras: financialInfos ? 1 : 0,
      guia_fornecedores_integracoes: integrations ? 1 : 0,
      guia_fornecedores_outrasinfos: othersInfos ? 1 : 0,
    };

    try {
      let companyIds = [],
        successful = 0,
        getAllCompanyIds = await findEmpresasV2(queryParams.empresa_cnpj);

      if (getAllCompanyIds.success)
        companyIds = getAllCompanyIds.data.map((e) => e.id);
      else
        throw new Error(
          "Ocorreu um erro ao buscar as empresas no sistema. Tente novamente."
        );

      if (!companyIds.length)
        throw new Error(
          "Nenhuma empresa encontrada para realizarmos a atualização."
        );

      for (const id of companyIds) {
        const updateSupplierParams = await updateEmpresasV2({
          empresa_cnpj: queryParams.empresa_cnpj,
          id: id,
          body: supplierParamsBody,
        });

        if (updateSupplierParams.success) successful++;
      }

      if (successful === companyIds.length) {
        Object.keys(supplierParamsBody).forEach((key) => {
          if (supplierParamsBody[key] || supplierParamsBody[key] === 0) {
            sessionStorage.setItem(key, supplierParamsBody[key].toString());
            supplierParamsBody[key] = supplierParamsBody[key].toString();
          } else {
            sessionStorage.setItem(key, "");
            supplierParamsBody[key] = "";
          }
        });

        setQueryParams((current) => ({ ...current, ...supplierParamsBody }));
        setOpen(false);
        return notify("Parâmetros atualizados com sucesso!", true, "success");
      } else
        throw new Error(
          "Não conseguimos atualizar os parâmetros de todas as empresas. Tente novamente."
        );
    } catch (e) {
      notify(e, false, "error");
    } finally {
      setLoading(false);
    }
  };

  const switches = [
    {
      label: "Contatos",
      value: contacts,
      setValue: setContacts,
    },
    {
      label: "Informações Financeiras",
      value: financialInfos,
      setValue: setFinancialInfos,
    },
    {
      label: "Outras Informações",
      value: othersInfos,
      setValue: setOthersInfos,
    },
    {
      label: "Integrações",
      value: integrations,
      setValue: setIntegrations,
    },
  ];

  const tabTitles = [{ label: "Guias" }];

  const tabContents = [<TabGuias key="tab-guias-fornecedor" />];

  return {
    switches,
    tabTitles,
    tabContents,
    handleSaveSupplierParams,
  };
};

export default useFornecedoresBodyController;
